// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__H8zEy","title":"InfoRow_title__3lV70"};